import { render, staticRenderFns } from "./LinkActiveModelAndSimcard.vue?vue&type=template&id=4f8ee4d6"
import script from "./LinkActiveModelAndSimcard.vue?vue&type=script&lang=js"
export * from "./LinkActiveModelAndSimcard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports